import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Error from "shared/pages/error/Error";
import store from "./shared/store";

ReactDOM.render(
  <React.StrictMode>
    <Error>
      <Provider store={store}>
        <App />
      </Provider>
    </Error>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
